import { request3 } from '../../utils/request'
import { urlStringify } from '../../utils/index'

export default {
  // 内容发布 列表
  getmessages: option => {
    return request3('v1/vendormessage/getmessages', option, true)
  },
  // 获取内容
  getmessage: option => {
    const urls = urlStringify(option)
    return request3('v1/vendormessage/getmessage' + urls, {}, true, false)
  },
  // 内容发布 删除
  deletemessage: option => {
    const urls = urlStringify(option)
    return request3('v1/vendormessage/deletemessage' + urls, {}, true)
  },
  // 新增内容发布
  addmessage: option => {
    return request3('v1/vendormessage/addmessage', option, true, false)
  },
  // 修改内容发布
  updatemessage: option => {
    return request3('v1/vendormessage/updatemessage', option, true, false)
  },
  // 获取首页信息
  getportalhomepage: option => {
    const urls = urlStringify(option)
    return request3('v1/wxappportal/getportalhomepage' + urls, {}, true)
  },
  // 修改主页模版
  updateportalpage: option =>
    request3('v1/wxappportal/updateportalpage', option, true),
  // 获取积分商城商品列表
  getgoodslist: option =>
    request3('v1/points/exchangegoods/getgoodslist', option, true),
  // 获取已发布内容
  getpubablemessages: option => {
    return request3('v1/vendormessage/getpubablemessages', option, true)
  }
}
